class wHitRecord {
    constructor() {
        this.validHit_ = false;
        this.hitTimes_ = []; // sorted list of valid intersections
        this.hitId_ = -1;
    }

    isValidHit() {
        return this.validHit_;
    }
}

export { wHitRecord };
